module.exports = __webpack_public_path__ + "img/ShipIcon.2433cd4d.svg";